<template>
  <div>
    <v-toolbar dark
               color="primary">
      <v-toolbar-title class="white--text">{{title}}</v-toolbar-title>
      <span
        v-if="!isMobile"
        class="pl-3"
        style="font-size: 30px;">|</span>
      <!--AGENCY SCHEDULER NAVIGATION BUTTON-->
      <v-tooltip
        :disabled="!showTooltip"
        bottom
      >
        <v-btn flat
               slot="activator"
               v-if="!isMobile && showSchedulerButton"
               @click="goToScheduler"
        >
          Schedule
        </v-btn>
        <span>Go to Agency Scheduler Dashboard</span>
      </v-tooltip>
      <!--SERVICE LOGS NAVIGATION BUTTON-->
      <v-tooltip
        :disabled="!showTooltip"
        bottom
      >
        <v-btn flat
               slot="activator"
               v-if="!isMobile && showSLButton"
               @click="goToServiceLogs">
          Service Logs
        </v-btn>
        <span>Go to Service Log Dashboard</span>
      </v-tooltip>
      <!--SEARCH LOGS NAVIGATION BUTTON-->
      <v-tooltip
        :disabled="!showTooltip"
        bottom
      >
        <v-btn flat
               slot="activator"
               v-if="!isMobile && showSLButton"
               @click="goToSearchServiceLogs">
          Search Logs
        </v-btn>
        <span>Go to Search Service Logs</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <span class="subheading font-weight-medium pr-2">
        {{fullName}}
      </span>
      <v-menu
        transition="slide-y-transition"
        :open-on-hover="true"
        offset-y
      >
        <!--vertical icon and activator for the menu-->
        <v-btn
          slot="activator"
          dark
          icon
        >
          <v-icon>more_vert</v-icon>
        </v-btn>
        <!--menu items-->
        <v-list>
          <!--user preferences setting-->
          <v-list-tile
            @click="showDialog = true"
          >
            <v-icon class="pr-3">settings</v-icon>
            User Preferences
          </v-list-tile>
          <!--SERVICE LOGS HELP-->
          <v-list-tile
            v-if="showSLButton"
          >
            <v-icon class="pr-3">help</v-icon>
            <a
              target="_blank"
              :href="helpUrl"
            >
              Nursing Service Logs Help
            </a>
          </v-list-tile>
          <!--NURSING SCHEDULER HELP-->
          <v-list-tile
            v-if="showSchedulerButton"
          >
            <v-icon class="pr-3">help</v-icon>
            <a
              target="_blank"
              :href="helpUrlAdmin"
            >
              Nursing Scheduler Help
            </a>
          </v-list-tile>
          <!--logout-->
          <v-list-tile
            @click="logout"
          >
            <v-icon class="pr-3">exit_to_app</v-icon>
            Logout
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <div v-if="showDialog">
      <user-preferences
        v-on:dialog:closed="showDialog = false"
      >
      </user-preferences>
    </div>
  </div>
</template>

<script>
/* eslint-disable indent */
  import { mapGetters } from 'vuex';
  import JWTHelper from '@/jwt-token';
  import UserPreferences from '@/components/user-preferences/user-preferences.vue';

  export default {
    name: 'Toolbar',
    components: {
      UserPreferences
    },
    props: ['title'],
    computed: {
      ...mapGetters({
        showTooltip: 'showTooltip'
      }),
      isMobile() {
        return this.$mq === 'mobile';
      }
    },
    data() {
      return {
        showSLButton: null,
        showSchedulerButton: null,
        fullName: '',
        showDialog: false,
        helpUrl: `${process.env.HELP_URL}/nursing-service-logs/`,
        helpUrlAdmin: `${process.env.HELP_URL}/nursing-service-logs-admin/`
      };
    },
    created() {
      this.showSLButton = JWTHelper.hasServiceLogRights();
      this.showSchedulerButton = JWTHelper.hasSchedulerRights();
      this.fullName = JWTHelper.fullName();
    },
    methods: {
      logout() {
        localStorage.clear();
        // redirect to login page
        this.$router.push('/login');
      },
      goToServiceLogs() {
        this.$router.push('/dashboard');
      },
      goToSearchServiceLogs() {
        this.$router.push('/search');
      },
      goToScheduler() {
        this.$router.push('/agency-scheduler');
      }
    }
  };
</script>

<style scoped>
  #logout {
    font-weight: bold;
  }
  a {
    text-decoration: none;
    color: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/components/toolbar.vue